import axios, { CancelTokenSource } from 'axios';

/**
 * An utility function to create useEffect functions which will clean up pending Axios requests
 * when the component is unmounted.
 * @param callback
 */
export default function getUseEffectRequestWithCleanup(
  callback: (source: CancelTokenSource) => Promise<void>
) {
  const source = axios.CancelToken.source();
  (async () => {
    await callback(source);
  })();

  // Cleanup the request on unmount to prevent memory leaks
  return () => {
    source.cancel();
  };
}
